import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ImagesSavedCard from 'src/components/ConnectionIssueModals/ImagesSavedCard';
import SmallModalTemplate from 'src/components/SmallModalTemplate';

import { I18NextNS } from 'src/models/Language.model';

export type CancelExamConfirmationModalProps = {
  show: boolean;
  isCancelling: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function CancelExamConfirmationModal({
  show,
  isCancelling,
  onClose,
  onConfirm,
}: CancelExamConfirmationModalProps) {
  const { t } = useTranslation(I18NextNS.PAGES);

  return (
    <SmallModalTemplate
      show={show}
      onHide={onClose}
      data-test="cancel-exam-confirmation-modal"
      iconWrapperClassName="bg-danger-100"
      icon={
        <FontAwesomeIcon
          icon={faCircleXmark}
          className="text-danger"
          size="sm"
        />
      }
      title={t('newExam.cancelExam')}
      description={t('newExam.cancelExamConfirmation.description')}
      card={
        <ImagesSavedCard
          text={t('newExam.cancelExamConfirmation.imagesDiscarded')}
        />
      }
      leftButton={
        <Button
          variant="outline-primary"
          onClick={onClose}
          disabled={isCancelling}
          data-track="exam.analyzing-modal.cancel-exam-go-back"
          data-test="analyzing-modal-cancel-exam-go-back"
          data-observe
        >
          {t('newExam.cancelExamConfirmation.goBack')}
        </Button>
      }
      rightButton={
        <Button
          variant="danger"
          onClick={onConfirm}
          disabled={isCancelling}
          data-track="exam.analyzing-modal.cancel-exam-confirm"
          data-test="analyzing-modal-cancel-exam-confirm"
          data-observe
        >
          {t('newExam.cancelExam')}
        </Button>
      }
    />
  );
}
